export default __webpack_public_path__ + "dist/media/FileDocumentBg.2dfd6dec.svg";